import FieldBase from './FieldBase'

export default class extends FieldBase {
  constructor({ ...args }) {
    super(args)
    this.children = [this.getComponentWithVModel('image-input')]
  }
}
